import React from "react";
import { ArrowRight, Bell, ClipboardCheck, Mail } from "lucide-react";
import PageShell from "@/components/layout/PageShell";
import SubHero from "@/components/layout/SubHero";
import { Reveal } from "@/components/landing/Shared";
import { productUrl } from "@/config/siteUrls";

const Apply = () => (
  <PageShell>
    <SubHero
      testId="apply-hero"
      breadcrumb={[{ label: "Home", to: "/" }, { label: "Start here" }]}
      overline="Start here"
      headline="Begin with your"
      headlineAccent="Adaptive Assessment."
      lead="The assessment and personalized results are available now. Complete it to understand your nervous-system pattern and receive a practical starting direction."
    />

    <section className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-[1000px] px-6 sm:px-10 lg:px-16">
        <div className="grid gap-5 md:grid-cols-2">
          <Reveal>
            <article className="h-full rounded-[26px] p-7 forr-surface sm:p-9" style={{ border: "1px solid var(--forr-line)" }}>
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-teal-tint"><ClipboardCheck size={21} className="forr-text-teal-deep" /></div>
              <div className="mt-6 forr-overline">Available now</div>
              <h2 className="mt-2 font-display text-3xl forr-text-ink">Take the Adaptive Assessment</h2>
              <p className="mt-4 text-sm leading-relaxed forr-text-soft">
                See how activation, recovery, sleep, anxiety, emotion, environment, and repeated behaviour may be interacting in your nervous system.
              </p>
              <a href={productUrl("/assessment/start")} className="mt-7 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold forr-btn-primary">
                Begin assessment <ArrowRight size={16} />
              </a>
            </article>
          </Reveal>

          <Reveal delay={0.08}>
            <article className="h-full rounded-[26px] p-7 forr-surface sm:p-9" style={{ border: "1px solid var(--forr-line)" }}>
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-teal-tint"><Bell size={21} className="forr-text-teal-deep" /></div>
              <div className="mt-6 forr-overline">Coming soon</div>
              <h2 className="mt-2 font-display text-3xl forr-text-ink">Save your place for Companion</h2>
              <p className="mt-4 text-sm leading-relaxed forr-text-soft">
                Preview the APOS Companion and join the early-access list while subscriptions and payment access are prepared.
              </p>
              <a href={productUrl("/app#early-access")} className="mt-7 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold forr-btn-secondary">
                Preview Companion <ArrowRight size={16} />
              </a>
            </article>
          </Reveal>
        </div>

        <Reveal delay={0.14}>
          <div className="mt-7 rounded-[24px] p-7 forr-panel-information sm:p-9">
            <div className="flex items-start gap-4">
              <Mail size={20} className="mt-1 shrink-0 forr-text-teal-deep" />
              <div>
                <h2 className="font-display text-2xl forr-text-ink">Professional and organizational enquiries</h2>
                <p className="mt-3 text-sm leading-relaxed forr-text-soft">
                  For professional consultation, clinic integration, organizational partnerships, or guided implementation, contact FORR Health directly.
                </p>
                <a href="mailto:forrhealth.0@gmail.com" className="mt-5 inline-flex font-semibold forr-text-teal-deep">forrhealth.0@gmail.com</a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  </PageShell>
);

export default Apply;
